<div [ngClass]="component.width || ''">
    <div [grid]="[2,3,4,4][client.sizeId]"
         [gridRowGap]="2"
         [gridColumnGap]="2">
        @for (item of component.items; track item) {
        <div [gridColumn]="1">
            <href class="w-12 pos-relative"
                 [link]="item.link"
                 [ngClass]="component.ratio">
                <img [image]="item.image"
                     [alt]="item.title"
                     class="rf">

                @if (item.label){
                <div class="pos-absolute bg-col-w top-4 right-0 p-t-1 p-b-1 p-l-2 p-r-2"
                     sizeClass="XLM: o1, S: s3"
                     *iCms="'label' of item; content: 'html'">
                </div>
                }

                @if (isTop){
                <div class="pos-absolute z-1 col-w"
                     style="top: 5%; left: 5%; right: 0%;">
                    <div>
                        <span sizeClass="XL:h3,SM:s1"
                              *iCms="'title' of item; content: 'html'"></span>
                        <span class="s1 p-l-2 col-4"
                              *iCms="'title2' of item; content: 'html'"></span>
                    </div>
                    <span class="p2 p-t-1"
                          *iCms="'subtitle' of item; content: 'html'"></span>
                </div>
                }
            </href>
            @if (!isTop){
            <div>
                <span sizeClass="XL:h3,SM:s1"
                      *iCms="'title' of item; content: 'html'"></span>
                <span class="s1 p-l-2 col-12"
                      *iCms="'title2' of item; content: 'html'"></span>
            </div>
            <span class="p2 p-t-1"
                  *iCms="'subtitle' of item; content: 'html'"></span>
            }
        </div>
        }
    </div>
</div>
